import axios from 'axios'

// 创建axios实例
const service = axios.create({
	baseURL: '/api',
	timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		// 从localStorage获取token
		const token = localStorage.getItem('token')
		if (token) {
			config.headers.Token = token
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// 使用宽松比较，兼容字符串和数字类型的code
		if (res.code != 1) {
			// 错误处理
			return Promise.reject(new Error(res.msg || 'Error'))
		}
		return res
	},
	error => {
		// 处理401错误（token过期或未授权）
		if (error.response && error.response.status === 401) {
			// 清除登录状态
			localStorage.removeItem('token')
			localStorage.removeItem('userinfo')
			// 跳转到登录页
			window.location.href = '/login'
		} else if (error.response && error.response.status === 403) {
			// 处理403错误（无权限）
			// 跳转到无权限页面
			window.location.href = '/no-permission'
		}
		return Promise.reject(error)
	}
)

// 权限管理API
export const permissionApi = {
	// 获取权限列表
	getList() {
		return service.get('/permission/index')
	},
	// 获取权限树
	getTree() {
		return service.get('/permission/tree')
	},
	// 添加权限
	add(data) {
		return service.post('/permission/add', data)
	},
	// 编辑权限
	edit(data) {
		return service.post('/permission/edit', data)
	},
	// 删除权限
	delete(id) {
		return service.post('/permission/delete', {
			id
		})
	}
}

// 角色管理API
export const roleApi = {
	// 获取角色列表
	getList() {
		return service.get('/role/index')
	},
	// 获取角色详情
	getDetail(id) {
		return service.get('/role/detail', {
			params: {
				id
			}
		})
	},
	// 添加角色
	add(data) {
		return service.post('/role/add', data)
	},
	// 编辑角色
	edit(data) {
		return service.post('/role/edit', data)
	},
	// 删除角色
	delete(id) {
		return service.post('/role/delete', {
			id
		})
	},
	// 分配权限
	assign(data) {
		return service.post('/role/assign', data)
	}
}

// 管理员管理API
export const adminApi = {
	// 获取管理员列表
	getList(departmentId = '') {
		return service.get('/admin/index', {
			params: { department_id: departmentId }
		})
	},
	// 获取管理员详情
	getDetail(id) {
		return service.get('/admin/detail', {
			params: {
				id
			}
		})
	},
	// 添加管理员
	add(data) {
		return service.post('/admin/add', data)
	},
	// 编辑管理员
	edit(data) {
		return service.post('/admin/edit', data)
	},
	// 删除管理员
	delete(id) {
		return service.post('/admin/delete', {
			id
		})
	},
	// 重置密码
	resetPassword(id, password) {
		return service.post('/admin/resetPassword', {
			id,
			password
		})
	},
	// 管理员登录
	login(data) {
		return service.post('/admin/login', data)
	},
	// 退出登录
	logout() {
		return service.post('/admin/logout')
	},
	// 获取菜单
	getMenu() {
		return service.get('/admin/menu')
	},
	// 获取当前登录管理员信息（含企业名称）
	getInfo() {
			return service.get('/admin/getInfo')
		},
		// 价格权限：获取可选用户列表（含是否已授权）
		pricePermissionList() {
			return service.get('/admin/pricePermissionList')
		},
		// 价格权限：保存授权用户
		setPricePermission(userIds) {
			return service.post('/admin/setPricePermission', {
				user_ids: userIds
			})
		},
		// 小程序菜单权限：获取指定用户的权限
		getMiniMenuPermission(id) {
			return service.get('/admin/getMiniMenuPermission', { params: { id } })
		},
		// 小程序菜单权限：保存指定用户的权限
		setMiniMenuPermission(id, permissions) {
			return service.post('/admin/setMiniMenuPermission', { id, permissions })
		},
		// 编辑个人资料
		editProfile(data) {
			return service.post('/admin/editProfile', data)
		}
	}

// 部门管理API
export const departmentApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/department/index', {
			params: { page, limit, search, status }
		})
	},
	options() {
		return service.get('/department/options')
	},
	add(data) {
		return service.post('/department/add', data)
	},
	edit(data) {
		return service.post('/department/edit', data)
	},
	delete(id) {
		return service.post('/department/delete', { id })
	},
	status(id, status) {
		return service.post('/department/status', { id, status })
	}
}

export const customerApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/customer/index', {
			params: { page, limit, search, status }
		})
	},
	options() {
		return service.get('/customer/options')
	},
	add(data) {
		return service.post('/customer/add', data)
	},
	edit(data) {
		return service.post('/customer/edit', data)
	},
	delete(id) {
		return service.post('/customer/delete', { id })
	},
	status(id, status) {
		return service.post('/customer/status', { id, status })
	}
}

export const mediumApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/medium/index', {
			params: { page, limit, search }
		})
	},
	options() {
		return service.get('/medium/options')
	},
	add(data) {
		return service.post('/medium/add', data)
	},
	edit(data) {
		return service.post('/medium/edit', data)
	},
	delete(id) {
		return service.post('/medium/delete', { id })
	},
	status(id, status) {
		return service.post('/medium/status', { id, status })
	}
}

export const goodsTypeApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/goods_type/index', {
			params: { page, limit, search }
		})
	},
	options() {
		return service.get('/goods_type/options')
	},
	add(data) {
		return service.post('/goods_type/add', data)
	},
	edit(data) {
		return service.post('/goods_type/edit', data)
	},
	delete(id) {
		return service.post('/goods_type/delete', { id })
	},
	status(id, status) {
		return service.post('/goods_type/status', { id, status })
	}
}

export const certificateVolumeApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/certificate_volume/index', {
			params: { page, limit, search }
		})
	},
	options() {
		return service.get('/certificate_volume/options')
	},
	add(data) {
		return service.post('/certificate_volume/add', data)
	},
	edit(data) {
		return service.post('/certificate_volume/edit', data)
	},
	delete(id) {
		return service.post('/certificate_volume/delete', { id })
	},
	status(id, status) {
		return service.post('/certificate_volume/status', { id, status })
	}
}

// 容积管理API
export const volumeApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/volume/index', {
			params: { page, limit, search, status }
		})
	},
	options() {
		return service.get('/volume/options')
	},
	add(data) {
		return service.post('/volume/add', data)
	},
	edit(data) {
		return service.post('/volume/edit', data)
	},
	delete(id) {
		return service.post('/volume/delete', { id })
	},
	status(id, status) {
		return service.post('/volume/status', { id, status })
	}
}

// 证书管理API
export const certificateApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/certificate/index', {
			params: { page, limit, search, status }
		})
	},
	options() {
		return service.get('/certificate/options')
	},
	add(data) {
		return service.post('/certificate/add', data)
	},
	edit(data) {
		return service.post('/certificate/edit', data)
	},
	delete(id) {
		return service.post('/certificate/delete', { id })
	},
	status(id, status) {
		return service.post('/certificate/status', { id, status })
	}
}

export const salesPersonApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/sales_person/index', {
			params: { page, limit, search }
		})
	},
	options() {
		return service.get('/sales_person/options')
	},
	add(data) {
		return service.post('/sales_person/add', data)
	},
	edit(data) {
		return service.post('/sales_person/edit', data)
	},
	delete(id) {
		return service.post('/sales_person/delete', { id })
	},
	status(id, status) {
		return service.post('/sales_person/status', { id, status })
	}
}

export const inboundApi = {
	list(page = 1, limit = 10, search = '', type = '', start_date = '', end_date = '', medium_id = '', spec = '', property = '') {
		return service.get('/inbound/index', {
			params: { page, limit, search, type, start_date, end_date, medium_id, spec, property }
		})
	},
	add(data) {
		return service.post('/inbound/add', data)
	},
	edit(data) {
		return service.post('/inbound/edit', data)
	},
	delete(id) {
		return service.post('/inbound/delete', { id })
	},
	status(id, status) {
		return service.post('/inbound/status', { id, status })
	}
}

export const outboundApi = {
	list(page = 1, limit = 10, search = '', type = '') {
		return service.get('/outbound/index', {
			params: { page, limit, search, type }
		})
	},
	add(data) {
		return service.post('/outbound/add', data)
	},
	edit(data) {
		return service.post('/outbound/edit', data)
	},
	delete(id) {
		return service.post('/outbound/delete', { id })
	},
	status(id, status) {
		return service.post('/outbound/status', { id, status })
	}
}

export const orderOutboundApi = {
	list(page = 1, limit = 10, orderId = '', receiveStatus = '') {
		return service.get('/order_outbound/index', {
			params: { page, limit, order_id: orderId, receive_status: receiveStatus }
		})
	},
	detail(id) {
		return service.get('/order_outbound/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/order_outbound/add', data)
	},
	edit(data) {
		return service.post('/order_outbound/edit', data)
	},
	delete(id) {
		return service.post('/order_outbound/delete', { id })
	},
	updateStatus(id, receiveStatus) {
		return service.post('/order_outbound/updateStatus', { id, receive_status: receiveStatus })
	}
}

export const productionApi = {
	list(page = 1, limit = 10, search = '', status = '', start_date = '', end_date = '', order_type = '', invoice_status = '', is_paid = '', gas_composition = '', delivery_start_date = '', delivery_end_date = '') {
		return service.get('/production/index', {
			params: { page, limit, search, status, start_date, end_date, order_type, invoice_status, is_paid, gas_composition, delivery_start_date, delivery_end_date }
		})
	},
	add(data) {
		return service.post('/production/add', data)
	},
	edit(data) {
		return service.post('/production/edit', data)
	},
	quickUpdate(data) {
		return service.post('/production/quickUpdate', data)
	},
	// 导出Excel（按筛选条件）
	exportXlsx(params = {}) {
		return service.get('/production/exportXlsx', { params })
	},
	delete(id) {
		return service.post('/production/delete', { id })
	},
	status(id, status) {
		return service.post('/production/status', { id, status })
	},
	// 获取我的抄送列表
	ccList(page = 1, limit = 10, status = '', search = '') {
		const params = { page, limit }
		if (status !== '') params.status = status
		if (search) params.search = search
		return service.get('/production/ccList', { params })
	},
	// 确认抄收
	ccConfirm(id) {
		return service.post('/production/ccConfirm', { id })
	},
	// 获取订单详情
	detail(id) {
			return service.get('/production/detail', { params: { id } })
		},
		// 高纯气出库提交
		highPurityOutbound(data) {
			return service.post('/production/highPurityOutbound', data)
		}
	}

	export const gasApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/gas/index', {
			params: { page, limit, search, status }
		})
	},
	add(data) {
		return service.post('/gas/add', data)
	},
	edit(data) {
		return service.post('/gas/edit', data)
	},
	delete(id) {
		return service.post('/gas/delete', { id })
	},
	status(id, status) {
		return service.post('/gas/status', { id, status })
	}
}

export const dilutionApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/dilution/index', {
			params: { page, limit, search, status }
		})
	},
	detail(id) {
		return service.get('/dilution/detail', {
			params: { id }
		})
	},
	components(id) {
		return service.get('/dilution/components', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/dilution/add', data)
	},
	edit(data) {
		return service.post('/dilution/edit', data)
	},
	delete(id) {
		return service.post('/dilution/delete', { id })
	},
	status(id, status) {
		return service.post('/dilution/status', { id, status })
	}
}

export const developApi = {
	list(page = 1, limit = 10, search = '', status = '', order_id = '', other_type = null, start_date = '', end_date = '', is_manual = null, develop_user_id = '') {
		return service.get('/develop/index', {
			params: { page, limit, search, status, order_id, other_type, start_date, end_date, is_manual, develop_user_id }
		})
	},
	inspectionList(page = 1, limit = 10, search = '', inspectionStatus = '', other_type = null, is_manual = null) {
		return service.get('/develop/inspectionList', {
			params: { page, limit, search, inspection_status: inspectionStatus, other_type, is_manual }
		})
	},
	detail(id) {
		return service.get('/develop/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/develop/add', data)
	},
	edit(data) {
		return service.post('/develop/edit', data)
	},
	delete(id) {
		return service.post('/develop/delete', { id })
	},
	unbindOrder(id) {
		return service.post('/develop/unbindOrder', { id })
	},
	updatePrintStatus(id, type) {
		return service.post('/develop/updatePrintStatus', { id, type })
	},
	updateCylinderNo(id, cylinderNo) {
		return service.post('/develop/updateCylinderNo', { id, cylinder_no: cylinderNo })
	}
}

export const developOptionApi = {
	list(type) {
		return service.get('/develop_option/list', {
			params: { type }
		})
	},
	add(type, value) {
		return service.post('/develop_option/add', { type, value })
	},
	delete(id) {
		return service.post('/develop_option/delete', { id })
	}
}

export const inspectionApi = {
	list(page = 1, limit = 10, developId = 0, inspectionResult = '') {
		return service.get('/inspection/index', {
			params: { page, limit, develop_id: developId, inspection_result: inspectionResult }
		})
	},
	add(data) {
		return service.post('/inspection/add', data)
	},
	detail(id) {
		return service.get('/inspection/detail', {
			params: { id }
		})
	},
	delete(id) {
		return service.post('/inspection/delete', { id })
	}
}

export const statisticsApi = {
	dashboard() {
		return service.get('/statistics/dashboard')
	},
	production() {
		return service.get('/statistics/production')
	},
	inbound() {
		return service.get('/statistics/inbound')
	},
	outbound() {
		return service.get('/statistics/outbound')
	}
}

export const cylinderStatisticsApi = {
	overview() {
		return service.get('/cylinder_statistics/overview')
	},
	byMedium(type = 'inbound', mediumId = '', spec = '', property = '', customerId = '', start_date = '', end_date = '') {
		return service.get('/cylinder_statistics/byMedium', {
			params: { type, medium_id: mediumId, spec, property, customer_id: customerId, start_date, end_date }
		})
	},
	bySpec(type = 'inbound', mediumId = '', spec = '', property = '', customerId = '', start_date = '', end_date = '') {
		return service.get('/cylinder_statistics/bySpec', {
			params: { type, medium_id: mediumId, spec, property, customer_id: customerId, start_date, end_date }
		})
	},
	byProperty(type = 'inbound', mediumId = '', spec = '', property = '', customerId = '', start_date = '', end_date = '') {
		return service.get('/cylinder_statistics/byProperty', {
			params: { type, medium_id: mediumId, spec, property, customer_id: customerId, start_date, end_date }
		})
	},
	byCustomer(type = 'inbound', mediumId = '', spec = '', property = '', customerId = '', start_date = '', end_date = '') {
		return service.get('/cylinder_statistics/byCustomer', {
			params: { type, medium_id: mediumId, spec, property, customer_id: customerId, start_date, end_date }
		})
	},
	comprehensive(type = 'inbound', dimension = 'medium') {
		return service.get('/cylinder_statistics/comprehensive', {
			params: { type, dimension }
		})
	}
}

export const inspectorApi = {
	list() {
		return service.get('/inspector/index')
	},
	add(name) {
		return service.post('/inspector/add', { name })
	},
	delete(id) {
		return service.post('/inspector/delete', { id })
	}
}

// 企业管理API
export const enterpriseApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/enterprise/index', {
			params: { page, limit, search, status }
		})
	},
	detail(id) {
		return service.get('/enterprise/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/enterprise/add', data)
	},
	edit(data) {
		return service.post('/enterprise/edit', data)
	},
	delete(id) {
		return service.post('/enterprise/delete', { id })
	},
	status(id, status) {
		return service.post('/enterprise/status', { id, status })
	},
	options() {
		return service.get('/enterprise/options')
	},
	bindUser(adminId, enterpriseId) {
		return service.post('/enterprise/bindUser', {
			admin_id: adminId,
			enterprise_id: enterpriseId
		})
	}
}

export const unitApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/unit/index', {
			params: { page, limit, search, status }
		})
	},
	options() {
		return service.get('/unit/options')
	},
	add(data) {
		return service.post('/unit/add', data)
	},
	edit(data) {
		return service.post('/unit/edit', data)
	},
	delete(id) {
		return service.post('/unit/delete', { id })
	},
	status(id, status) {
		return service.post('/unit/status', { id, status })
	}
}

export const reportTemplateApi = {
	list(page = 1, limit = 10, search = '', templateType = '') {
		return service.get('/report_template/index', {
			params: { page, limit, search, template_type: templateType }
		})
	},
	detail(id) {
		return service.get('/report_template/detail', {
			params: { id }
		})
	},
	getByType(templateType) {
		return service.get('/report_template/getByType', {
			params: { template_type: templateType }
		})
	},
	save(data) {
		return service.post('/report_template/save', data)
	},
	delete(id) {
		return service.post('/report_template/delete', { id })
	}
}

export const scanConfigApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/scan_config/index', {
			params: { page, limit, search }
		})
	},
	detail(id) {
		return service.get('/scan_config/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/scan_config/add', data)
	},
	edit(data) {
		return service.post('/scan_config/edit', data)
	},
	delete(id) {
		return service.post('/scan_config/delete', { id })
	},
	status(id, status) {
		return service.post('/scan_config/status', { id, status })
	}
}

export const cylinderApi = {
	list(page = 1, limit = 10, search = '', status = '') {
		return service.get('/cylinder/index', {
			params: { page, limit, search, status }
		})
	},
	detail(id) {
		return service.get('/cylinder/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/cylinder/add', data)
	},
	edit(data) {
		return service.post('/cylinder/edit', data)
	},
	delete(id) {
		return service.post('/cylinder/delete', { id })
	},
	status(id, status) {
		return service.post('/cylinder/status', { id, status })
	},
	options() {
		return service.get('/cylinder/options')
	}
}

// 合同管理API
export const contractApi = {
	list(page = 1, limit = 10, search = '') {
		return service.get('/contract/index', {
			params: { page, limit, search }
		})
	},
	detail(id) {
		return service.get('/contract/detail', {
			params: { id }
		})
	},
	add(data) {
		return service.post('/contract/add', data)
	},
	edit(data) {
		return service.post('/contract/edit', data)
	},
	delete(id) {
		return service.post('/contract/delete', { id })
	},
	// 乙方信息历史检索（按名称模糊查询）
		partyBSuggest(keyword = '') {
			return service.get('/contract/partyBSuggest', {
				params: { keyword }
			})
		}
	}

	export const contractSettingsApi = {
		get() {
			return service.get('/contract_settings/get')
		},
		save(data) {
			return service.post('/contract_settings/save', data)
		},
		cylinderUsageList() {
			return service.get('/contract_settings/cylinderUsageList')
		},
		cylinderUsageSave(values) {
			return service.post('/contract_settings/cylinderUsageSave', { values })
		}
	}

	export default service